/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum SubstanceAttributeType {
  FUNCTION = "function",
  SMILES = "smiles",
  CANONICAL_SMILES = "canonical_smiles",
  INFO_SOURCE = "info_source",
  CHEMICAL_CLASS = "chemical_class",
  INGREDIENT_SOURCE = "ingredient_source",
  TECHNICAL_NAME = "technical_name",
  CAS_NUMBER = "cas_number",
  EC_NUMBER = "ec_number",
  INCI_NAME = "inci_name",
  KOREAN_NAME = "korean_name",
  JAPANESE_NAME = "japanese_name",
  CHINESE_NAME = "chinese_name",
  EMPIRICAL_FORMULA = "empirical_formula",
  IUPAC_NAME = "iupac_name",
}
